/**
 * Yerel QR üretimi.
 *
 * 2FA `otpauth://` URI'si **gizli anahtarı** taşır. Bu URI dış bir QR
 * servisine gönderilmemelidir; QR tarayıcıda, ağa çıkmadan üretilir.
 */
export async function qrDataUrl(value: string): Promise<string> {
  // Dinamik import: QR kütüphanesi yalnız 2FA kurulum ekranı açıldığında
  // yüklenir; ana sayfa bundle'ını büyütmez.
  const { default: QRCode } = await import('qrcode');
  return QRCode.toDataURL(value, {
    width: 150,
    margin: 1,
    errorCorrectionLevel: 'M',
  });
}
